import React from 'react';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { FormFieldWrapper } from '../FormFieldWrapper';
import { MultiSelect, MultiSelectChangeEvent } from '@progress/kendo-react-dropdowns';

interface FormMultiSelectProps extends FieldRenderProps {
  isLoading?: boolean;
  onFilterChange?: (value: string) => void;
  onSelectionChange?: (value: any) => void;
}

export const FormMultiSelect: React.FC<FormMultiSelectProps> = fieldRenderProps => {
  const { defaultValue, value, choices, name, disabled, isLoading, onFilterChange, onSelectionChange } =
    fieldRenderProps;

  if (!name) {
    return <></>;
  }

  const deserializeValue = (raw: any): any[] => {
    if (Array.isArray(raw)) {
      return raw;
    }
    if (!raw) {
      return [];
    }
    if (typeof raw === 'string') {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          return parsed;
        }
        if (parsed) {
          return [parsed];
        }
      } catch {
        // empty
      }
    }
    return [];
  };

  const normalizedValue = deserializeValue(value);
  const normalizedDefaultValue = deserializeValue(defaultValue);
  const shouldUseDefaultValue = value === undefined || value === null || value === '';

  const handleFilterChange = (event: any) => {
    if (onFilterChange) {
      onFilterChange(event.filter.value);
    }
  };

  const handleChange = (event: MultiSelectChangeEvent) => {
    if (onSelectionChange) {
      onSelectionChange(event.target.value);
    }
  };

  return (
    <FormFieldWrapper
      validationMessage={fieldRenderProps.validationMessage}
      value={fieldRenderProps.value}
      touched={fieldRenderProps.touched}
      id={fieldRenderProps.id}
      valid={fieldRenderProps.valid}
      disabled={fieldRenderProps.disabled}
      hint={fieldRenderProps.hint}
      label={fieldRenderProps.label}
      wrapperStyle={fieldRenderProps.wrapperStyle}
      optional={fieldRenderProps.optional}
      modified={fieldRenderProps.modified}
      visited={fieldRenderProps.visited}
      onChange={fieldRenderProps.onChange}
      onFocus={fieldRenderProps.onFocus}
      onBlur={fieldRenderProps.onBlur}
      name={fieldRenderProps.name}
      isLoading={isLoading}
    >
      <MultiSelect
        data={choices}
        value={shouldUseDefaultValue ? normalizedDefaultValue : normalizedValue}
        onChange={handleChange}
        onFilterChange={handleFilterChange}
        filterable={!!onFilterChange}
        id={fieldRenderProps.name.toString()}
        validationMessage={fieldRenderProps.validationMessage || undefined}
        disabled={disabled}
      />
    </FormFieldWrapper>
  );
};
